import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a20e1bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#ffffff"} }
const _hoisted_2 = { class: "inquiry-right-div" }
const _hoisted_3 = { class: "search-div margin-top-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-left-div" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "SCAN USER ID:")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "search-right-div" }
const _hoisted_6 = { class: "search-div margin-top-20" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-left-div" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "Email address:")
], -1 /* HOISTED */))
const _hoisted_8 = { class: "search-right-div" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "※This feature can be used to initialize your own password or to re-initialize someone else's expired passwsord.", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertmessage,
      alertState: $setup.alertstate
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.menuTile }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "txtSearch",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event)),
            placeholder: "USER ID"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.userId]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            class: "txtSearch",
            type: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event)),
            placeholder: "example@example.com"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.email]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btnGo",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.sendEmail()))
          }, " Go ")
        ])
      ]),
      _hoisted_9,
      _hoisted_10
    ])
  ]))
}